/**
 * TabletIcon/index.js
 * desc: tablet icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const TabletIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="tablet icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.tablet.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 14 22" xmlns="http://www.w3.org/2000/svg"><path d="M1.99 0l10 .01c1.1 0 2 .89 2 1.99v18c0 1.1-.9 2-2 2h-10C.89 22 0 21.1 0 20V2C0 .9.89 0 1.99 0zm0 18h10V4h-10v14z" /></svg>
    </IconButton>
);


export default TabletIcon;
